import { useSnackbarCustom } from "hooks/useSnackCustom";
import { IAbstractModel } from "model/abstract.model";
import { FlowConsignadoItemDTO } from "pages/consignado/detail/consignado-detail.model";
import { SituacaoConsignado } from "pages/consignado/situacao-consignado.model";
import { IProdutoRow } from "pages/registra-venda/registra-venda.model";
import { useState } from "react";
import { setTabelaPreco } from "redux/features/configuracoes";
import {
  atualizaValoresItensConsignado,
  setTabelaPrecoConsignado,
} from "redux/features/consignadoSlice";
import { atualizaValoresItensPedido } from "redux/features/stateSlice";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import TabelaPrecoService from "service/tabela-preco.service";
import useCustomLocation from "utils/useCustomLocation";

const useTabelaPreco = () => {
  const dispatch = useAppDispatch();
  const { addError } = useSnackbarCustom();
  type StateLocal = {
    showConfirmaExclusao: boolean;
    produtosParaExcluir: string[];
    tabelaPrecoTemp: IAbstractModel | null;
    data: any;
    length: number;
  };

  const { isTelaRegistraConsignado, isTelaDevolucaoConsignado } =
    useCustomLocation();

  const isTelasConsignado = () => {
    return isTelaRegistraConsignado() || isTelaDevolucaoConsignado();
  };

  const [stateLocal, setStateLocal] = useState<StateLocal>({
    showConfirmaExclusao: false,
    produtosParaExcluir: [],
    tabelaPrecoTemp: null,
    data: [],
    length: 0,
  });

  const { itens, itensTroca } = useAppSelector((e) => e.state.pedido);
  const { tableData } = useAppSelector((e) => e.consignado);

  const getItensToUse = () => {
    if (isTelasConsignado()) {
      return tableData[SituacaoConsignado.ABERTO];
    }
    return [...itens, ...itensTroca];
  };

  const tabelaPrecoService = TabelaPrecoService();

  const getProduto = (item: IProdutoRow | FlowConsignadoItemDTO) => {
    if ("produto" in item) {
      return item.produto;
    }
    if ("sku" in item) {
      return item.sku;
    }
    throw new Error("não é IProdutoRow nem FlowConsignadoItemDTO");
  };

  const _atualizaTabela = (tabelaPreco: IAbstractModel) => {
    if (isTelasConsignado()) {
      dispatch(setTabelaPrecoConsignado(tabelaPreco));
    } else {
      dispatch(setTabelaPreco(tabelaPreco));
    }
  };

  const atualizarOuRemoverItensPedido = (
    tabelaPreco: IAbstractModel,
    setTabela?: (tabela: IAbstractModel) => void
  ) => {
    const produtosComSku = getItensToUse();
    const array: string[] = Array.from(
      new Set(produtosComSku.map((e) => getProduto(e).codigoSku))
    );
    if (array.length === 0) {
      return setTabela?.(tabelaPreco) ?? _atualizaTabela(tabelaPreco);
    }
    tabelaPrecoService
      .revalidaSkus(array, tabelaPreco.uuid)
      .then(({ data }: { data: any[] }) => {
        const skusPerdidos: string[] = array.filter(
          (_, index) => data[index] === null
        );
        const produtosParaExcluir: string[] = [];

        skusPerdidos.forEach((e) => {
          getItensToUse().forEach((el) => {
            const produto = getProduto(el);
            const descricaoProduto = `${produto.codigoSku} - ${produto.nome} / ${produto.cor} / ${produto.tamanho}`;
            if (
              produto.codigoSku === e &&
              !produtosParaExcluir.includes(descricaoProduto)
            ) {
              produtosParaExcluir.push(descricaoProduto);
            }
          });
        });
        if (skusPerdidos.length) {
          setStateLocal((prevState) => ({
            ...prevState,
            showConfirmaExclusao: true,
            produtosParaExcluir: produtosParaExcluir,
            tabelaPrecoTemp: tabelaPreco,
            data: data,
            length: skusPerdidos.length,
          }));
        } else {
          if (isTelasConsignado()) {
            dispatch(atualizaValoresItensConsignado(data));
          } else {
            dispatch(atualizaValoresItensPedido(data));
          }
          setTabela?.(tabelaPreco) ?? _atualizaTabela(tabelaPreco);
          // setTimeout(() => {
          //   addSuccess({
          //     id: "tabela-preco-salva-com-sucesso",
          //     message: "Tabela de Preço alterada com sucesso!",
          //     closeable: true,
          //     hideDuration: 5000,
          //     preventDuplicate: true,
          //   });
          // }, 500);
        }
      })
      .catch(() => {
        addError({ message: "Erro ao revalidar SKUs.", closeable: true });
      });
  };

  return {
    dadosAlterarTabelaPrecoState: stateLocal,
    setDadosAlterarTabelaPrecoState: setStateLocal,
    atualizarOuRemoverItensPedido,
  };
};

export default useTabelaPreco;
